import { AfterViewInit, Component, Input } from '@angular/core';
import { CartridgeBookingService } from '../services/cartridge-booking.service';
import { BookingWorkflowData } from '../booking/model/booking.model';

@Component({
  selector: 'markant-platform-booking-confirmation',
  templateUrl: './booking-confirmation.component.html',
  styleUrls: ['./booking-confirmation.component.scss'],
})
export class BookingConfirmationComponent implements AfterViewInit {
  @Input() bookingData!: BookingWorkflowData;

  constructor(private readonly cartridgeBookingService: CartridgeBookingService) {
    window.scroll(0, 0);
  }

  ngAfterViewInit(): void {
    this.cartridgeBookingService.pushTrackingEventData('Step 03 - Completed', this.bookingData, 'Pageview');
  }

  getEntryLocation(): string[] {
    if (this.bookingData.priceRequest) {
      return [CartridgeBookingService.ORGANIZATION_PRICE_REQUEST_URL + this.bookingData.priceRequest.id];
    } else {
      return ['/cartridge', 'catalog', this.bookingData.cartridge.id, 'detail'];
    }
  }
}
